import { ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES,
    ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS,
    ESTACIO_INTRODUCCIO_METADADES_AFEGIR_METADADA,
    ESTACIO_INTRODUCCIO_METADADES_ELIMINAR_METADADA,
    ESTACIO_INTRODUCCIO_METADADES_MODIFICAR_METADADA } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = {
    originals: {},
    editades: {}
};

const metadades = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES:
            return {
                originals: action.estructuraIDades.dades.metadades,
                editades: action.estructuraIDades.dades.metadades
            };

        case ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS:
            return {
                ...state,
                editades: state.originals
            };

        case ESTACIO_INTRODUCCIO_METADADES_AFEGIR_METADADA:
            return {
                ...state,
                editades: {...state.editades, [action.idMetadada]: {} }
            };
        case ESTACIO_INTRODUCCIO_METADADES_ELIMINAR_METADADA: {
            let editadesSenseMetadada = {...state.editades};
            delete editadesSenseMetadada[action.idMetadada];

            return {
                ...state,
                editades: editadesSenseMetadada
            };
        }

        case ESTACIO_INTRODUCCIO_METADADES_MODIFICAR_METADADA: {
            let editadesMetadadaModificada = {...state.editades};
            editadesMetadadaModificada[action.idMetadada] = {...editadesMetadadaModificada[action.idMetadada], [action.idCamp]:  action.valors};

            return {
                ...state,
                editades: editadesMetadadaModificada
            };
        }

        default:
            return state;
    }
};

export default metadades;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/dades/metadades.js